let Prius = (function () {
    /**
     * callback 数据结构
     * {
    *    callId: "XXX",
    *    onSuccess: "xxxx",
    *    onFail: "xxxx",
    *    onCancel: "xxxxx",
    * }
     * 保存所有的callback回调
     */
    let [globalListener, callbackList, lookup] = [{}, {}, null]

    /**
     * 通用操作PATH列表
     */
    let PATH_LIST = {
        LOCATION: "location",   // 获取定位城市
        SHARE: "share",   // 内容分享
        PAY_WEIXIN: "pay/weixin",   // 微信支付订单
        PAY_ALIPAY: "pay/alipay",   // 支付宝支付订单
        OPEN_NEW_PAGE: "open/newpage", // 打开新页面
        APP_TOAST: "app/toast", // 显示toast
        APP_DIALOG: "app/dialog", // 显示Dialog
        APP_SHOW_LOADING: "app/showloading", //显示loading加载
        APP_HIDE_LOADING: "app/hideloading", //隐藏loading加载
        //APP_SHOW_LOADING_DIALOG: "app/showloadingdialog", //显示loading dialog
        //APP_HIDE_LOADING_DIALOG: "app/hideloadingdialog", //隐藏loading dialog
        MENU_ICON: "menu/icon", //添加icon menu
        MENU_WORD: "menu/word", //添加word menu
        MENU_DELETE_ALL: "menu/deleteall", //删除全部menu
        USER_LOGIN: "user/login", //获取用户信息
        //PAGE_HOME: "page/home", //打开首页
        PAGE_LOGIN: "page/login", //打开用户登录页面
        PAGE_END: "page/end", //page end
        PAGE_BACK: "page/back", // 回退到上一页
        HEAD_HIDE_BACK: "menu/hidebackmenu" , // 隐藏返回按钮.
        BACKPAGE: "open/backpage"
    }

    /**
     * prius公共方法
     * */
    let util = {
        getVersion: function () {
            if (this.isBoole('AtourBrowser')) {
                let ua = window.navigator.userAgent
                let version = ua.replace(/([\s\S]*)AtourBrowser-(\S*)\/(\S*)\/([\S\s]*)/, "$3")
                if (version !== '#')
                    return version
            }
            return null
        },

        isBoole: function (s) {
            if (window.navigator.userAgent) {
                let ua = window.navigator.userAgent
                if (s && (ua.indexOf(s, 0) != -1))
                    return true
            }
            return false
        }
    }

    /**
     * prius对象
     * */
    let prius = {
        scheme: 'atourlife://',
        isInsideApp: util.isBoole('AtourBrowser'),  // 判断是否在APP应用内
        isAtourLife: util.isBoole('AtourLife'), // 是否在亚朵应用内
        isAtourControl: util.isBoole('AtourControl'),   // 是否在亚朵控制端应用内
        clientVersion: util.getVersion(),   // 获得当前终端的版本号
        isIOS: util.isBoole('iOS'),
        isAndroid: util.isBoole('android'),
        lastOpenTime: 0,

        /**
         * 触发全局监控事件
         * @param eventId eventId
         * @param data data
         * data的数据结构为 （其中的data需要做base64加密）
         * {
             *  token: "xxxx"
             *  other: "xxxx"
             * }
         */
        fireGlobalEvent: function (eventId, data) {
            if (globalListener && eventId && globalListener[eventId]) {
                globalListener[eventId].onGlobalEvent(data ? JSON.parse(data) : "");
            }
        },

        /**
         * native执行全局事件
         * @param encodeEvent encodeEvent
         * @param encodeData encodeData
         */
        nativeFireGlobalEvent: function (encodeEvent, encodeData) {
            if (encodeEvent) {
                let event = encodeEvent ? base64.decode(encodeEvent) : "";
                let data = encodeData ? base64.decode(encodeData) : "";
                this.fireGlobalEvent(event, data);
            }
        },

        /**
         * 添加全局监听事件
         * @param eventId eventId
         * @param listener listener
         * @returns {boolean} 是否添加成功
         * listener的数据结构
         * {
                 *  onGlobalEvent(data)
                 * }
         */
        addGlobalEventListener: function (eventId, listener) {
            if (eventId && listener) {
                if (globalListener[eventId]) {
                    return true;
                }
                globalListener[eventId] = listener;
                return true;
            }
            return false;
        },

        /**
         * 删除全局监控事件
         * @param eventId eventId
         * @returns {boolean} 是否删除成功
         */
        removeGlobalEventListener: function (eventId) {
            if (eventId) {
                if (globalListener[eventId]) {
                    delete globalListener[eventId];
                    return true;
                }
            }
            return false;
        },

        /**
         * 执行访问native的url
         */
        nativeExecute: function (actionUrl) {
            setTimeout(function () {
                let iframe = document.createElement("IFRAME");
                iframe.setAttribute("src", actionUrl);
                document.documentElement.appendChild(iframe);
                iframe.parentNode.removeChild(iframe);
                iframe = null;
            }, 0);
        },


        /**
         * 将请求体Json数据加密后处理成scheme格式
         * @param path path
         * @param params params
         */
        executeActionUrl: function (path, params) {
            let actionUrl = this.scheme + path;
            if (params) {
                actionUrl += "?param=" + base64.encode("string" === typeof params ? params : JSON.stringify(params));
            }
            this.nativeExecute(actionUrl);
        },

        /**
         * 添加一个交互回调
         * @param callback callback
         * @return {boolean} 是否添加回调成功
         */
        addCallback: function (callback) {

            if (callback && callback.callId && callbackList) {

                callbackList[callback.callId] = callback.listener;
                console.log(callbackList)
                return true;
            }
            return false;
        },


        /**
         * 移除一个交互回调
         * @param callback callback
         * @return {boolean} 是否删除回调成功
         */
        removeClientCall: function (callback) {
            if (callback && callback.callId && callbackList && callbackList[callback.callId]) {
                delete callbackList[callback.callId];
                return true;
            }
            return false;
        },

        /**
         * 回调成功事例，json数据格式为以下
         * {
        *    callId: "xxxx/xxxx",
        *    data: {
        *    }
        *  }
         */
        onCallbackDone: function (origin) {
            if (origin) {
                let result = JSON.parse(base64.decode(origin));
                if (result && result.callId) {
                    let callback = callbackList[result.callId];
                    callback.apply(this,[result]);
                } else {
                    console.log("CallbackDone.callId is null!");
                }
            }
            console.log("Fail onCallbackDone, something wrong can't callback!");
        },

        /**
         * 外链打开新的页面加载，并且是带返回按钮
         * @data link 需要打开的网页链接
         * @data title 标题
         * @data showTitle {value: "0"-不添加actionbar， “1”-添加actionbar}
         */
        openNewPage: function (request) {
            let curTime = new Date().getTime();
            if (curTime - this.lastOpenTime < 500) {
                return;
            }
            this.lastOpenTime = curTime;
            let data = request.data;
            this.appEvent('OPEN_NEW_PAGE',data);
        },

        /**
         * @listener 回调事件对象
         * */
        login: function (request) {
            request.callId = PATH_LIST.USER_LOGIN + (new Date().getTime());
            this.addCallback(request);
            this.appEvent('USER_LOGIN');
        },

        /**
         * 执行app事件
         * */
        appEventCallback: function (request) {
            let data = request.data;
            request.callId = PATH_LIST[request.event];
            this.addCallback(request);
            this.appEvent(request.event,data);
        },

        /**
         * 执行app事件
         * */
        appEvent: function (event,data) {
            let params = {
                callId: PATH_LIST[event],
                data: data?data:{}
            };
            prius.executeActionUrl(PATH_LIST[event], params);
        },

        /**
         * 执行关闭当前页
         * */
        backpage: function (request) {
            request.callId = PATH_LIST.BACKPAGE;
            this.addCallback(request);
            this.appEvent('BACKPAGE');
        }
    }

    return prius
})()

export default Prius;


// WEBPACK FOOTER //
// ./src/assets/js/jsBridge.js